var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPhotio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 25,
    viewBox: "0 0 200 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_18055)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 24.6551,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13035 6.23383H12.2604V12.3636H6.13035V6.23383ZM6.13035 18.4937H0V24.6238H6.13035V18.4937ZM6.13035 18.4937H18.39V0.10376H0V12.3639H6.13035V18.4937Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8619 10.7148H71.6535V2.47955e-05H68.4326V24.651H71.6535V13.9359H89.8619V24.651H93.0831V2.47955e-05H89.8619V10.7148Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.88 24.651H168.101V1.33514e-05H164.88V24.651Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.047 21.4295C108.027 21.4295 103.943 17.3455 103.943 12.3255C103.943 7.30556 108.027 3.22129 113.047 3.22129C118.068 3.22129 122.152 7.30556 122.152 12.3255C122.151 17.3455 118.068 21.4295 113.047 21.4295ZM113.047 0.000169754C106.251 0.000169754 100.722 5.52927 100.722 12.3255C100.722 19.122 106.251 24.6509 113.047 24.6509C119.844 24.6509 125.373 19.122 125.373 12.3255C125.373 5.52927 119.844 0.000169754 113.047 0.000169754Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.674 21.4298C182.654 21.4298 178.57 17.3455 178.57 12.3256C178.57 7.30563 182.654 3.22135 187.674 3.22135C192.695 3.22135 196.779 7.30563 196.779 12.3256C196.779 17.3455 192.695 21.4298 187.674 21.4298ZM187.674 0.000230789C180.878 0.000230789 175.349 5.52934 175.349 12.3256C175.349 19.1221 180.878 24.6509 187.674 24.6509C194.471 24.6509 200 19.1221 200 12.3256C200 5.52934 194.471 0.000230789 187.674 0.000230789Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7966 1.26723C56.618 0.438316 55.2349 8.58307e-05 53.7963 8.58307e-05H36.1133V3.22121H53.7963C55.8622 3.22121 57.5429 4.90213 57.5429 6.96804C57.5429 9.03395 55.8622 10.7149 53.7963 10.7149H36.1133V24.6511H39.3347V13.936H53.7963C55.2352 13.936 56.6186 13.4978 57.7966 12.6688C58.4587 12.2032 59.0306 11.6313 59.4971 10.9686C60.326 9.79033 60.7643 8.4069 60.7643 6.96804C60.7643 5.52946 60.326 4.14603 59.4971 2.96745C59.0309 2.30508 58.459 1.73318 57.7966 1.26723Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.643 3.22142H143.357V24.651H146.579V3.22142H157.293V2.47955e-05H132.643V3.22142Z",
    fill: "#002061"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_18055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 24.6551,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPhotio);
export default __webpack_public_path__ + "static/media/LogoPhotio.beea1dd1685ed252618179a8c87bed19.svg";
export { ForwardRef as ReactComponent };